import React, { useRef } from 'react';
import { handleKeyBoardNavigation } from './handleKeyBoardNavigation';
import * as Styles from './styles';
/**
 * Componente Tab do Design System OLX.
 * O Tab é utilizado em conjunto com os componentes Tabs e TabPanel. Ele representa o botão selecionável que ativa a exibição do conteúdo associado.
 */
export const Tab = _ref => {
  let {
    label,
    icon,
    selected,
    disabled,
    onSelectTab,
    id
  } = _ref;
  const tabButtonRef = useRef(null);
  const tabClassNames = [selected && 'selected', disabled && 'disabled'].filter(Boolean).join(' ');
  return React.createElement(Styles.TabButton, {
    id: id,
    role: "tab",
    "aria-selected": selected,
    "aria-controls": "panel-".concat(id),
    className: tabClassNames,
    onClick: () => onSelectTab === null || onSelectTab === void 0 ? void 0 : onSelectTab(id),
    onKeyDown: event => handleKeyBoardNavigation({
      event,
      tabButtonRef,
      onSelectTab
    }),
    tabIndex: selected ? 0 : -1,
    disabled: disabled,
    ref: tabButtonRef,
    "data-ds-component": "DS-Tabs-Button",
    "data-testid": "tab-button"
  }, icon && React.createElement(Styles.TabIcon, null, icon), React.createElement(Styles.TabLabel, {
    weight: "semibold"
  }, label));
};
Tab.displayName = 'Tab';